// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyCtaFooter-cls1_DSB","cls2":"StickyCtaFooter-cls2__qO StickyCtaFooter-cls1_DSB"};